import { motion, AnimatePresence } from 'framer-motion';
import { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { RiGithubFill, RiLinkedinFill, RiFacebookFill, RiArrowUpLine } from 'react-icons/ri';
import Image from '../../images/ujjal-zaman-nyc.jpg';
const LINKS = [
  { to: 'about',      label: 'About'      },
  { to: 'experience', label: 'Experience' },
  { to: 'projects',   label: 'Work'       },
  { to: 'education',  label: 'Education'  },
  { to: 'contact',    label: 'Contact'    },
];

const SOCIALS = [
  { icon: RiGithubFill,   href: 'https://github.com/Ujjalzaman',label: 'GitHub'    },
  { icon: RiLinkedinFill, href: 'https://www.linkedin.com/in/ujjal-zaman', label: 'LinkedIn'  },
  { icon: RiFacebookFill, href: 'https://www.facebook.com/ujjal.zaman',label: 'Facebook' },
];

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handler = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <>
      <footer className="relative border-t border-white/[0.05] py-12 overflow-hidden">
        <div className="absolute inset-0 bg-ink-900/60" />
        <div className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse 60% 100% at 50% 100%, rgba(99,102,241,0.04) 0%, transparent 70%)' }} />

        <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">

            <Link to="hero" smooth duration={600} className="cursor-pointer group flex items-center gap-2.5">
              <div className="relative w-9 h-9 flex items-center justify-center">
                <img src={Image} alt="Ujjal Zaman" className="w-full h-full object-cover rounded-xl" />
              </div>
              <div>
                <p className="font-display font-bold text-sm text-white leading-tight">Ujjal Zaman</p>
                <p className="font-mono text-[10px] text-zinc-700">Full-Stack Developer</p>
              </div>
            </Link>

            {/* Nav */}
            <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
              {LINKS.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to} smooth duration={600} offset={-64}
                  className="text-sm text-zinc-600 hover:text-white transition-colors cursor-pointer link-underline"
                >
                  {label}
                </Link>
              ))}
            </nav>

            {/* Social */}
            <div className="flex items-center gap-2">
              {SOCIALS.map(s => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.label}
                    href={s.href}
                    target="_blank" rel="noopener noreferrer"
                    aria-label={s.label}
                    className="w-9 h-9 flex items-center justify-center rounded-xl glass border border-white/[0.05]
                               text-zinc-600 hover:text-white hover:border-white/20 transition-all duration-200"
                  >
                    <Icon className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-white/[0.04] flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="font-mono text-xs text-zinc-800">
              © {new Date().getFullYear()} Ujjal Zaman. All rights reserved.
            </p>
            <p className="font-mono text-xs text-zinc-800">
             
            </p>
          </div>
        </div>
      </footer>

      <AnimatePresence>
        {showTop && (
          <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{    opacity: 0, scale: 0.6 }}
            className="fixed bottom-8 right-6 z-50"
          >
            <Link to="hero" smooth duration={700}>
              <motion.button
                whileHover={{ y: -3, scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="w-11 h-11 flex items-center justify-center rounded-2xl bg-indigo-600 hover:bg-indigo-500
                           text-white shadow-glow-sm hover:shadow-glow-md transition-all duration-200 cursor-pointer"
                aria-label="Scroll to top"
              >
                <RiArrowUpLine className="w-5 h-5" />
              </motion.button>
            </Link>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
